#import "../fragments/digest-subscription-fragment.graphql"

query GetDigestConfiguration($digestType: DigestTypeEnum!) {
    digestConfiguration(digestType: $digestType) {
        subscription {
            ...DigestSubscriptionFragment
        }
        nextSendDate
    }
}
